import { useRef, useCallback } from 'react'

const moderatorColors = ['#FF0707', '#011627', '#41EAD4', '#A0C578', '#FF9F1C']

export function useModeratorUsername() {
  // Mapa y puntero de color sin provocar re-renders
  const userColorMapRef = useRef({})
  const nextColorIndexRef = useRef(0)

  const getModeratorColorByUsername = useCallback((username) => {
    const map = userColorMapRef.current
    if (map[username]) {
      return map[username]
    }

    const idx = nextColorIndexRef.current % moderatorColors.length
    const assignedColor = moderatorColors[idx]

    // Asignación sincrónica para evitar múltiples incrementos en el mismo render
    map[username] = assignedColor
    nextColorIndexRef.current = nextColorIndexRef.current + 1

    // Si quieres loguear, hazlo sólo cuando se asigna:
    // console.debug('Color asignado', username, assignedColor, 'idx', idx)

    return assignedColor
  }, [])

  return { getModeratorColorByUsername }
}
